import { useState } from 'react'
import { DefaultOptionType } from 'antd/es/select'
import { sortBy, startCase } from 'lodash-es'

import { ISelectOption } from '$/types'
import {
  findLookupTablesFromBaseSettings,
  useGetBaseSettingsQuery
} from 'app/services/api/basesettings'
import { SelectDropdownWrapper } from 'common/components/SelectDropdownWrapper'
import { IGroupColumnsSelection } from 'features/RiskManagement/Components/Tables'

interface IThreatDropdownProps {
  setGroupColumns: (args: IGroupColumnsSelection[]) => void
}

interface IThreats {
  Id: number
  Name: string
  TypeCode: 'POF' | 'COF'
}
const ThreatDropdown = ({ setGroupColumns }: IThreatDropdownProps) => {
  const { lookupTables } = useGetBaseSettingsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      lookupTables: findLookupTablesFromBaseSettings(data)
    })
  })

  const [selectedThreatValue, setSelectedThreatValue] = useState<
    string | undefined
  >()

  // REVIEW: should memoize this?
  const threatOptions: ISelectOption[] = []

  lookupTables?.details.forEach((table) => {
    if (table.key === 'Threat') {
      const threats = table.value as unknown as Array<IThreats>

      threats.forEach((threat) => {
        if (threat.TypeCode === 'POF') {
          threatOptions.push({
            label: startCase(threat.Name),
            value: threat.Id.toString()
          })
        }
      })
    }
  })

  const onThreatSelection = (selection: DefaultOptionType | undefined) => {
    if (selection == null) {
      setGroupColumns([])
      setSelectedThreatValue(undefined)
    } else {
      const id = Number(selection.value)

      setGroupColumns([
        {
          id,
          name: selection.label?.toString() ?? '',
          groupTypeColumns: undefined
        }
      ])
      setSelectedThreatValue(selection.value as string)
    }
  }

  return (
    <div className='flex items-center'>
      <label className='font-semibold text-gray-700'>Threat</label>
      <SelectDropdownWrapper
        className='mx-2 w-64'
        options={sortBy(threatOptions, 'label')}
        value={selectedThreatValue}
        showSearch
        onChangeSelections={(selections) => {
          onThreatSelection(selections?.[0])
        }}
      />
    </div>
  )
}

export default ThreatDropdown
